import "./KDataTable.scss";
import KDataTableHeader from "./KDataTableHeader";
import KDataTableSubheader from "./KDataTableSubheader";
import { VDataTable, VIcon } from "vuetify/lib";

export default VDataTable.extend( {
	name: "KDataTable",

	inheritAttrs: false,

	props: {
		expandFlat: Boolean,
		hasErrors: Boolean,
		hiddenCols: {
			default: () => [],
			type: [ Array, Object, String ]
		},
		validationMode: {
			default: "aggressive",
			type: String
		}
	},

	computed: {
		slotsToWrap() {
			return {
				"no-data": this.noDataText,
				"no-results": this.noResultsText
			};
		},

		slotNamesToWrap() {
			return Object.keys( this.slotsToWrap );
		},

		slotNames() {
			return Object.keys(
				Object.assign(
					{},
					this.slotsToWrap,
					this.$slots
				)
			);
		},

		propsToPass() {
			const props = {};

			Object.keys( this.$props ).forEach( prop => {
				if ( prop in VDataTable.options.props ) {
					props[prop] = this.$props[prop];
				}
			} );

			return props;
		},

		modifiedSlots() {
			return this.slotNames.map( slotName => {
				let slotContent;

				if ( this.loading ) {
					slotContent = "Loading...";
				} else if ( this.$slots[slotName] ) {
					slotContent = this.$slots[slotName];
				} else if ( this.slotsToWrap.hasOwnProperty( slotName ) ) {
					slotContent = this.$vuetify.lang.t( this.slotsToWrap[slotName] );
				}

				if ( this.slotNamesToWrap.indexOf( slotName ) !== -1 ) {
					slotContent = this.wrapSlot( slotContent );
				}

				return <template slot={slotName} key={slotName}>
					{slotContent}
				</template>;
			} );
		},

		modifiedLoading() {
			if ( this.loading === "" || this.loading === true ) {
				return "link";
			}

			return this.loading;
		},

		modifiedDense() {
			return this.dense && Boolean( this.items.length );
		},

		hiddenColsArr() {
			if ( Array.isArray( this.hiddenCols ) ) {
				return this.hiddenCols;
			} else if ( typeof this.hiddenCols === "string" ) {
				return [ this.hiddenCols ];
			}

			return Object.keys( this.hiddenCols ).filter( col =>
				Boolean( this.hiddenCols[col] )
			);
		},

		$_headers() {
			let headers;

			if ( this.headers.length ) {
				headers = this.headers;
			} else if ( this.defaultHeaders.length ) {
				headers = this.defaultHeaders;
			} else {
				headers = [];
			}

			return headers.filter( header =>
				Boolean( header ) && this.hiddenColsArr.indexOf( header.value ) === -1
			);
		}
	},

	methods: {
		wrapSlot( slotContent ) {
			return [
				<VIcon left small={this.modifiedDense}>info</VIcon>,
				slotContent
			];
		},

		isColHidden( col ) {
			return this.hiddenColsArr.indexOf( col ) !== -1;
		},

		isColVisible( col ) {
			return !this.isColHidden( col );
		}
	},

	render() {
		return <VDataTable
			class={{
				"k-data-table": true,
				"k-data-table--expand-flat": this.expandFlat,
				"k-data-table--loading": this.modifiedLoading,
				"k-data-table--mobile": this.isMobile
			}}
			attrs={{
				...this.propsToPass,
				dense: this.modifiedDense,
				loading: this.modifiedLoading
			}}
			on={this.$listeners}
			scopedSlots={this.$scopedSlots}
		>
			{( this.$scopedSlots.title || this.$scopedSlots.subtitle )
				&& <template slot="top">
					{this.$scopedSlots.title
						&& <KDataTableHeader hasErrors={this.hasErrors}>
							{this.$scopedSlots.title()}
						</KDataTableHeader>
					}

					{this.$scopedSlots.subtitle
						&& <KDataTableSubheader>
							{this.$scopedSlots.subtitle()}
						</KDataTableSubheader>
					}
				</template>
			}

			{this.modifiedSlots}
		</VDataTable>;
	}
} );
